import React from 'react'
import './LeftSectionBar.scss';
function LeftSectionBar({children}) {
  return (
    <div className='leftSectionBar'>
        {children}
    </div>
  )
}

export default LeftSectionBar